import { createFileRoute } from '@tanstack/react-router';

import { safeNext, useNavState } from '@/lib/nav-state';
import { SignInScreen } from '@/screens/auth/SignInScreen';

/** The page to return to travels in history state, not in the URL (no `?next=`). */
export const Route = createFileRoute('/_auth/sign-in')({
  component: SignInRoute,
});

function SignInRoute() {
  const { next } = useNavState();
  return <SignInScreen next={safeNext(next) ?? undefined} />;
}
